// The human-friendly ticket number (#12). A ticket's real key is a uuid — nobody
// can read one out in a standup or paste it into chat — so every ticket also
// carries a short sequential number, and this is how it's shown everywhere:
// the admin board, the ticket detail, and the reporter's own "My reports".
// Tapping it copies "#12" and stops the click there, so grabbing a number from a
// card never also opens the card (the card stays the big tap target around it).
import { useState } from 'react';

export default function TicketNo({ n, tone = 'muted' }) {
  const [copied, setCopied] = useState(false);
  if (!n) return null; // a ticket filed before numbering simply shows nothing
  const label = `#${n}`;
  function copy(e) {
    e.stopPropagation();
    e.preventDefault();
    navigator.clipboard?.writeText(label)
      .then(() => { setCopied(true); setTimeout(() => setCopied(false), 1400); })
      .catch(() => {});
  }
  return (
    <span
      role="button"
      tabIndex={0}
      aria-label={`Ticket ${label} — copy`}
      title={copied ? 'Copied' : `Copy ${label}`}
      onClick={copy}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') copy(e); }}
      style={{
        display: 'inline-flex', alignItems: 'center', minHeight: 22, padding: '2px 7px', borderRadius: 6,
        fontSize: 11, fontWeight: 700, fontFamily: 'ui-monospace, monospace', fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap', cursor: 'pointer', userSelect: 'text', WebkitUserSelect: 'text',
        ...(tone === 'brand'
          ? { color: 'var(--brand)', background: 'rgba(var(--brand-rgb), 0.12)' }
          : { color: 'var(--muted)', background: 'rgba(128,128,128,0.14)' }),
      }}
    >
      {copied ? '✓ copied' : label}
    </span>
  );
}
